<button (click)="onCeilingChartClick()" class="ceiling-chart">
  <div id="ceiling-chart" class="plotly-graph"></div>
</button>
